module.exports = __webpack_public_path__ + "img/category-popular.6464c047.png";